import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  ToggleButtonGroup, 
  ToggleButton
} from '@mui/material';
import { useSelector } from 'react-redux';
import { selectDealerSelected } from '../Header/selectors';


// Import both versions
import LegacyMiaChatPage from './Legacy';
import V2MiaChatPage from './V2';

type MiaChatVersion = 'legacy' | 'v2';

function MiaChatPageWrapper() {
  const selectedDealer = useSelector(selectDealerSelected);
  const selectedDealerId = selectedDealer.dealer || '';
  const [version, setVersion] = useState<MiaChatVersion>('v2'); // Default to V2

  // Persist version selection in localStorage
  useEffect(() => {
    const savedVersion = localStorage.getItem('miaChatVersion') as MiaChatVersion;
    if (savedVersion && ['legacy', 'v2'].includes(savedVersion)) {
      setVersion(savedVersion);
    }
  }, []);

  const handleVersionChange = (
    _event: React.MouseEvent<HTMLElement>,
    newVersion: MiaChatVersion,
  ) => {
    if (newVersion !== null) {
      setVersion(newVersion);
      localStorage.setItem('miaChatVersion', newVersion);
    }
  };

  if (!selectedDealerId) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
          color: 'text.secondary',
          fontSize: '1.5rem',
          fontWeight: 500,
        }}
      >
        <Typography variant="h4" gutterBottom component="div">
          Please select a dealer
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative' }}>

      {/* Leonardo.ai Style Toggle - Top Right */}
      <Box
        sx={{
          position: 'absolute',
          top: 12,
          right: 12,
          zIndex: 1001, // Increased z-index to ensure it's above all content
        }}
      >
        <ToggleButtonGroup
          value={version}
          exclusive
          onChange={handleVersionChange}
          size="small"
          sx={{
            backgroundColor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '16px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
            '& .MuiToggleButton-root': {
              border: 'none',
              px: 1.5,
              py: 0.5,
              fontSize: '0.75rem',
              fontWeight: 500,
              minWidth: '65px',
              height: '28px',
              textTransform: 'none',
              color: 'text.secondary',
              '&.Mui-selected': {
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              },
              '&:hover': {
                backgroundColor: 'action.hover',
              },
            },
          }}
        >
          <ToggleButton value="legacy">
            V1
          </ToggleButton>
          <ToggleButton value="v2">
            V2
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* Content Area */}
      <Box >
        {version === 'legacy' ? <LegacyMiaChatPage /> : <V2MiaChatPage />}
      </Box>
    </Box>
  );
}

export default MiaChatPageWrapper;
